import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { SettingsService } from 'src/app/services/settings/settings.service';

import { BRAND_FOOTER_LINKS, Brands } from 'src/app/shared/constants/brands.constants';
import { BrandService } from 'src/app/shared/services/brand/brand.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  links: { label: string; route: string }[];
  year = new Date();
  brand = Brands.REGUS;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    private settings: SettingsService,
    private brandService: BrandService
  ) {}

  ngOnInit(): void {
    this.brand = this.brandService.getCurrentBrand();
    const linksUnmapped = Object.entries(BRAND_FOOTER_LINKS);
    this.links = linksUnmapped.map(([route, label]) => ({
      route: this.settings.formLink(route),
      label
    }));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
